import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import SearchBar from 'tuc-webui-base/components/SearchBar';
import { useRowNumber } from 'tuc-webui-base/components/TableViewComponent';
import { TABLE_PANEL_TYPE } from 'grb-webui/ComponentTypes';
import { withStoreData } from 'grb-webui/store';
import DefaultFilterBar, { withPageFilter } from 'grb-webui/components/FilterBar';
import AppMainPage, { FIT_TO_PAGE_VARIANT } from '../../components/AppMainPage';
import withJobs from './withJobs';
import JobFilter from './JobFilter';
import './JobsContainer.scss';
import { HISTORY_JOBS_TYPE } from '../../ComponentTypes';

export default (options = {}) => {
  const {
    jobsEntity,
    entities,
    jobType,
    FilterBar = DefaultFilterBar,
    paging,
    refreshPage,
  } = options;

  const JobsTablePage = (props) => {
    const {
      filter,
      arrayFilter,
      onFilterChange,
      filterEditor,
      onUpdateJobs,
      [jobsEntity]: jobs,
      search,
      onSearchChange,
      configuration,
      ...rest
     } = props;
    const [TablePanel] = useState(() => props.viewService.getComponent(TABLE_PANEL_TYPE));
    const jobsCount = useRowNumber(paging ? null : jobs, false, jobType === HISTORY_JOBS_TYPE /* Server filtering */);
    // Job log
    const { location, history, route, jobService } = rest;
    const handleJobDashboard = useCallback((job) => {
      history.push(jobService.getJobDashboardURL(job), { referrer: location });
    }, [history, location, jobService, route]);

    const filteredJobs = arrayFilter ? arrayFilter(jobs) : jobs;

    return (
      <AppMainPage
        route={props.route}
        variant={FIT_TO_PAGE_VARIANT}
        TrailingBar={(
          <React.Fragment>
            <FilterBar
              {...rest}
              filter={filter || {}}
              filterEditor={filterEditor}
              onFilterChange={onFilterChange}
              jobs={jobs}
            />
            {!paging && (
              <SearchBar
                {...props}
                placeholder="Search jobs table..."
                value={search}
                onChange={onSearchChange}
              />
            )}
          </React.Fragment>
        )}
        pageTitle={jobType === HISTORY_JOBS_TYPE ? 'History jobs' : undefined}
        className={classnames('grb-jobs-page', `grb-${jobType}-page`)}
        rowCount={jobsCount}
        onRefresh={refreshPage ? onUpdateJobs : undefined}
        refreshButtonId={refreshPage ? (refreshPage.buttonId || 'update-jobs') : undefined}
        refreshButtonTooltip={refreshPage ? (refreshPage.buttonLabel || 'Refresh the jobs page') : undefined}
        help={configuration && configuration.help}
      >
        <div className={classnames('grb-jobs-table-panel', 'grb-fullpage', 'MuiPaper-elevation4')}>
          <TablePanel
            {...rest}
            {...(rest.components ? rest.components[0] : rest.component)}
            jobs={filteredJobs}
            jobsCount={jobsCount}
            onJobDashboard={handleJobDashboard}
          />
        </div>
      </AppMainPage>
    );
  };

  JobsTablePage.propTypes = {
    [jobsEntity]: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.shape({})),
      PropTypes.shape({
        data: PropTypes.arrayOf(PropTypes.shape({})),
      }),
    ]),
    viewService: PropTypes.shape({
      onError: PropTypes.func,
      getComponent: PropTypes.func,
    }).isRequired,
    route: PropTypes.shape({}).isRequired,
    component: PropTypes.shape({}),
    components: PropTypes.arrayOf(PropTypes.shape({})),
    arrayFilter: PropTypes.func,
    onFilterChange: PropTypes.func,
    filter: PropTypes.shape({
      length: PropTypes.string,
    }),
    filterEditor: PropTypes.shape({}),
    onUpdateJobs: PropTypes.func,
    search: PropTypes.string,
    onSearchChange: PropTypes.func,
    configuration: PropTypes.shape({
      help: PropTypes.shape({}),
    }),
  };

  JobsTablePage.defaultProps = {
    [jobsEntity]: [],
    component: undefined,
    components: undefined,
    filter: undefined,
    arrayFilter: undefined,
    onFilterChange: undefined,
    filterEditor: undefined,
    onUpdateJobs: undefined,
    search: undefined,
    onSearchChange: undefined,
    configuration: undefined,
  };

  return withJobs(
    withPageFilter(
      withStoreData(JobsTablePage, {
        entities,
        onUpdateStore: refreshPage ? 'onUpdateJobs' : undefined,
      }),
      options.createFilter
        ? options.createFilter(options, JobFilter(options))
        : JobFilter(options),
    ),
    options,
  );
};
